import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import NotificationSystem from '../components/NotificationSystem'

export default function Notifications() {
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()
  const [filter, setFilter] = useState<'all' | 'unread' | 'mentions' | 'replies' | 'follows'>('all')

  if (!isLoggedIn) {
    return (
      <div className="notifications-page">
        <div className="container">
          <div className="auth-required">
            <h1>Login Required</h1>
            <p>You must be logged in to view your notifications.</p>
            <button 
              onClick={() => navigate('/login')}
              className="btn-primary"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="notifications-page">
      <div className="container">
        <div className="page-header">
          <nav className="breadcrumb">
            <span>Notifications</span>
          </nav>
          
          <div className="page-title">
            <h1>Notifications</h1>
            <p>Stay updated with mentions, replies, and community activity</p>
          </div>
        </div>

        <div className="notifications-filters">
          <button 
            onClick={() => setFilter('all')}
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
          >
            All
          </button>
          <button 
            onClick={() => setFilter('unread')}
            className={`filter-btn ${filter === 'unread' ? 'active' : ''}`}
          >
            Unread
          </button>
          <button 
            onClick={() => setFilter('mentions')}
            className={`filter-btn ${filter === 'mentions' ? 'active' : ''}`}
          >
            Mentions
          </button>
          <button 
            onClick={() => setFilter('replies')}
            className={`filter-btn ${filter === 'replies' ? 'active' : ''}`}
          >
            Replies
          </button>
          <button 
            onClick={() => setFilter('follows')}
            className={`filter-btn ${filter === 'follows' ? 'active' : ''}`}
          >
            Follows
          </button>
        </div>

        <NotificationSystem 
          showInline={true}
          maxVisible={50}
        />
      </div>
    </div>
  )
}